import { useState } from 'react';
import { Alert, Button, Form, Input } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { AuthKart } from '../components/AuthKart';
import { hataDurumu, parolaApi } from '../api/parola';

const GENEL_MESAJ = 'Adres kayıtlı ve doğrulanmışsa birkaç dakika içinde bir bağlantı gelecek.';

export function SifremiUnuttum() {
  const [loading, setLoading] = useState(false);
  const [gonderildi, setGonderildi] = useState(false);
  const [hata, setHata] = useState<string | null>(null);

  const onFinish = async ({ email }: { email: string }) => {
    setLoading(true);
    setHata(null);
    try {
      await parolaApi.unuttum(email.trim());
      setGonderildi(true);
    } catch (error) {
      if (hataDurumu(error) === 429) {
        setHata('Çok fazla deneme. Birkaç dakika sonra tekrar deneyin.');
      } else {
        setHata('İstek gönderilemedi. Bağlantınızı kontrol edip tekrar deneyin.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthKart altBaslik="Şifremi unuttum">
      {gonderildi ? (
        <Alert type="success" showIcon title={GENEL_MESAJ} style={{ marginBottom: 16 }} />
      ) : (
        <Form name="sifremi-unuttum" layout="vertical" size="large" onFinish={onFinish}>
          <p style={{ color: 'rgba(0,0,0,0.65)', marginTop: 0 }}>
            Hesabınızın e-posta adresini yazın; parolanızı yenilemeniz için bir bağlantı gönderelim.
          </p>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'E-posta gerekli' },
              { type: 'email', message: 'Geçerli bir e-posta girin' },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="E-posta" autoComplete="email" />
          </Form.Item>
          {hata && <Alert type="error" showIcon title={hata} style={{ marginBottom: 16 }} />}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} block>
              Bağlantı gönder
            </Button>
          </Form.Item>
        </Form>
      )}
      <div style={{ textAlign: 'center' }}>
        <Link to="/login">Girişe dön</Link>
      </div>
    </AuthKart>
  );
}
